import React from 'react';
import { useTranslation } from 'react-i18next';
import { timesheetsStatuses } from '../../../../utils/constants';
import classes from './StatusColorPoint.module.scss';

export default function StatusColorPoint(props) {
  const { status, isApprover = false } = props;

  const { t } = useTranslation();
  return (
    <div className={classes.statusWrapper}>
      <p className={classes.label}>{timesheetsStatuses(t, isApprover)[status].label}</p>
      <div
        data-testid="point"
        className={classes.point}
        style={{ backgroundColor: timesheetsStatuses(t, isApprover)[status].color }}
      />
    </div>
  );
}
